import { F360Product } from "@/core/@types/types";
import { F360PageTitles } from "@/core/router/F360PageTitles";
import useF360Router from "@/core/router/useF360Router";
import type { RouteRecordRaw } from "vue-router";
import { EInsightsIARoutes } from "./types";

const { handleRouterPrefixName } = useF360Router();

export const insightsIARouter: Array<RouteRecordRaw> = handleRouterPrefixName(
  [
    {
      path: "/insights-ia",
      component: () =>
        import("@/features/financas/views/InsightsIA/InsightsIABase.vue"),
      name: EInsightsIARoutes.Index,
      meta: {
        module: F360Product.FinancasNewHorizons,
        requireAuth: true,
        title: F360PageTitles.InsightsIA
      },
      children: [
        {
          path: "/insights-ia/dre",
          component: () =>
            import("@/features/financas/views/InsightsIA/views/agenteDeDRE/InsightsAgenteDeDRE.vue"),
          name: EInsightsIARoutes.AgenteDeDRE,
          meta: {
            title: F360PageTitles.InsightsIADRE
          }
        },
        {
          path: "/insights-ia/fluxo-de-caixa",
          component: () =>
            import("@/features/financas/views/InsightsIA/views/agenteDeFluxoDeCaixa/InsightAgenteDeFDC.vue"),
          name: EInsightsIARoutes.AgenteDeFluxoDeCaixa,
          meta: {
            title: F360PageTitles.InsightsIAFluxoDeCaixa
          }
        }
      ]
    }
  ],
  F360Product.FinancasNewHorizons
);
